import { ContextMenuProps } from "../../../elements/context-menu";
import { CalendarSelectRepeatOptionsProps } from "./CalendarSelectRepeatOptions";
import {AppState} from "@stores/AppState";

export const openCalendarSelectRepeatOptionsCtxMenu = (
    appState: AppState,
    targetElement: HTMLElement,
    params: CalendarSelectRepeatOptionsProps,
    ctxMenuProps: {id: string} & Partial<ContextMenuProps>,
) => {
    const maxWidth = targetElement.getBoundingClientRect().width;

    appState.addAdditionalContextMenu({
        type: "calendar-select-repeat-options",
        isDark: false,
        menuPlacement: "block-end",
        menuAlignment: "start",
        VERTICAL_SHIFT: 0,
        HORIZONTAL_SHIFT: 0,
        withPointer: false,
        withOverlay: false,
        shouldForcePlace: true,
        getTargetBoundingBox: targetElement.getBoundingClientRect.bind(targetElement),
        params: {
         ...params
        },
        minWidth: maxWidth,
        ...ctxMenuProps,
    });
};
